import { render, staticRenderFns } from "./CellSplitDialog.vue?vue&type=template&id=b0264ef2&scoped=true"
import script from "./CellSplitDialog.vue?vue&type=script&lang=js"
export * from "./CellSplitDialog.vue?vue&type=script&lang=js"
import style0 from "./CellSplitDialog.vue?vue&type=style&index=0&id=b0264ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0264ef2",
  null
  
)

export default component.exports